import { useMemo } from 'react'

import { FormConfig } from '@workwave-tidal/core/form'

import { Footer } from './components/Footer'
import { FormContent } from './components/Form'

import { useVoiceData } from '../../hooks/useVoiceData'
import { useFormConfig } from './hooks/useFormConfig'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'

import { form } from './formState'
import type { VoiceFormValues } from './typings'

interface Props {
  onDiscard: () => void
}

export function VoiceForm(props: Props) {
  const { onDiscard } = props

  const onSubmit = useOnSubmit(onDiscard)

  const texts = useTexts()
  const [voice] = useVoiceData()
  const initialValues = useFormConfig(voice)

  const config = useMemo<FormConfig<VoiceFormValues>>(
    () => ({
      id: 'voice-form',
      initialValues: initialValues,
    }),
    [initialValues],
  )

  return (
    <form.Form
      testId="voice-form"
      title={texts.header.title}
      subtitle={texts.header.subtitle}
      footer={<Footer />}
      onSubmit={onSubmit}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
    >
      <FormContent />
    </form.Form>
  )
}
